import { Feature } from 'geojson';
import { DdtFilingManagerModule } from '@features/due-date-tracker/ddt-filing-manager.module';
import { Component, ComponentFactoryResolver, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ExpertCornerShortArticle, PowerSearchDashboardConfig, Query } from '../models/power-search.model';
import { select, Store } from '@ngrx/store';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { IPowerSearchState } from '../store/reducer/power-search.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { getCurrentProject, ProjectState } from '../../projects/store/reducers/projects.reducer';
import { VisualizerNotificationService } from '../Services/visualizer-notification.service';
import {
  GetPowerSearchAnalyticReportSuccessAction,
  GetPowerSearchDashboardConfigSuccessAction,
  SetEntityStatusAction
} from '../store/action/power-search-actions';
import { filter, take, takeUntil } from 'rxjs/operators';
import { DashboardService } from '@core/services/dashboard.service';
import { getUserDisplayName, getUserInfo, hasFeature } from '@shared/store/selectors/security.selector';
import { PlatformMessageBar } from '@shared/models/platform-tool-models';
import { Configuration } from '@shared/models/configuration';
import { UserInfo } from '@shared/models/user-info.model';
import { Api } from '@shared/constants/common-field.constants';
import { PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { PlatformQuery, PlatformQueryResponse } from "@shared/models/platform-query/platform-query";
import { PlatformQueryService } from "@core/services/platform-query.service";
import { DialogService } from "@shared/services/dialog-service";
import { DialogModel } from "@shared/models/dialog.model";
import { XatBotHomePageModel, XatBotQuestionModel } from "@shared/models/xatbot/xatbot.model";
import { XatBotDataService } from "@features/xatbot/services/xat-bot-data.service";
import {XatBotLicenseTypes} from '@features/xatbot/models/xat-bot-context.model';
import { A } from '@angular/cdk/keycodes';
import { WorkspaceSyncFollower } from '../workspace-sync/workspace-sync-follower';

@Component({
    standalone: false,
    selector: 'particle-power-search-dashboard-v2',
  templateUrl: './power-search-dashboard-v2.component.html',
  styleUrls: ['./power-search-dashboard-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PowerSearchDashboardV2Component implements OnInit, OnDestroy {
  pageDictionary = {
    "entities": "Entity Rates And Entity Attributes",
    "transactions": "Transactions",
    "tax-news" : "Tax News",
    "law-changes" : "Law Changes",
    "tax-treaties" : "Tax Treaties",
    "tax-topics" : "Tax Topics"
  }
  redirectUrlDict = {
    "tax-news" : "itrce/analytics",
    "law-changes" : "cr/law-changes/analytics",
    "tax-treaties" : "itrce/analytics",
    "tax-topics" : "itrce/analytics"
  }
  ngUnsubscribe: Subject<void>;
  powerSearchConfig: PowerSearchDashboardConfig;
  selectedGroup: string;
  selectedGroupReports: any;
  failureResponse: any;
  failureResponse$: Observable<any>;
  dataLoaded: boolean;
  private currentMenuIndex: number;
  private projectId: string;
  isExpertCornerArticleAvailable = false;
  expertCornerArticle: ExpertCornerShortArticle;
  hasFeature$: Observable<any>;
  messageBarContent = new PlatformMessageBar();
  userInfo: UserInfo;
  isDAC6MdrResourceVisible: boolean;
  isDAC6MdrResourceVisible1: boolean;
  isDAC6MdrResourceVisible2: boolean;
  userDisplayName$: any;
  countryCount = 0;
  private currentProjectCountries = [];
  currentClientFeature: (featureId: string) => boolean;
  xatBotHomePageModel: XatBotHomePageModel;
  isLicensedUser: Boolean;
  xatBotSuggestedQuestions: string[] = [];
  xatBotHomePageModelText: { title: string; description: string; buttonText: string; state: 'try' | 'open' | 'upgrade' };

  requireWorkspaceSync: boolean = false;
  workspaceSyncMessageBar: PlatformMessageBar;
  private workspaceSync: WorkspaceSyncFollower;
  hasKPMGFeature = false;
  homePageName = '';
  isSelfRegistered: boolean;
  xatBotLicenseType: string;

  constructor(
    private securityStore: Store<SecurityState>,
    private dashboardService: DashboardService,
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    private powerSearchStore: Store<IPowerSearchState>,
    private router: Router,
    private projectStore: Store<ProjectState>,
    private platformQueryService: PlatformQueryService,
    private dialogService: DialogService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private activatedRoute: ActivatedRoute,
    private xatBotDataService: XatBotDataService
  ) {
    this.ngUnsubscribe = new Subject<void>();
    this.workspaceSync = new WorkspaceSyncFollower(securityStore, platformQueryService, this.ngUnsubscribe,
      response => this.showWorkspaceSync(response));
    this.messageBarContent.message = '<strong>Would you like to receive the Daily Orbitax Tax News Digest to your inbox? ' +
      '<a id="subscribe">Click here to subscribe</a> ' +
      'or you can ' +
      '<a id="close">close this message</a></strong>.';
    this.messageBarContent.fieldValues = {};
  }

  ngOnInit() {
    this.homePageName = Configuration.getConfig("homePageName");
    this.isSelfRegistered = Configuration.getConfig("isSelfRegistered");
    this.xatBotLicenseType = Configuration.getConfig("xatBotLicenseType");
    this.setXatBotSuggestedQuestions();
    this.xatBotDataService.isLicensedUser().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this.isLicensedUser = res;
    });
    this.setXatBotHomePageModel();
    this.userDisplayName$ = this.securityStore.select(getUserDisplayName);
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
    this.hasFeature$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(feature => {
      this.currentClientFeature = feature;
      if (feature('TAX-ALERT-ONLY')) {
        this.router.navigateByUrl('/taxnews');
      }
      if (feature('EXPERT-DASHBOARD')) {
        this.router.navigateByUrl('/expert-services/service-workspace');
      }
    });
    this.getCountryList();
    this.isDAC6MdrResourceVisible = true;
    this.isDAC6MdrResourceVisible1 = true;
    this.isDAC6MdrResourceVisible2 = true;
    this.fuseSplashScreenService.show();
    this.powerSearchStore.dispatch(new GetPowerSearchAnalyticReportSuccessAction(null));
    this.projectStore.pipe(select(getCurrentProject), filter(val => val != null && val != undefined), takeUntil(this.ngUnsubscribe)).subscribe(response => {
      this.projectId = response.ProjectId;
      this.dashboardService.getEntityStatus(this.projectId).subscribe(response => {
        this.powerSearchStore.dispatch(new SetEntityStatusAction(response['hasEntities']));
      });
    });
    this.currentMenuIndex = 0;
    this.dashboardService.getPowerSearchDashboardConfig().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(response => {
        if (response) {
          this.powerSearchConfig = response;
          this.selectedGroupReports = this.updateDisplayText(this.powerSearchConfig.powerQueries[0].reports);
          this.selectedGroup = this.powerSearchConfig.powerQueries[0].group;
          this.powerSearchStore.dispatch(new GetPowerSearchDashboardConfigSuccessAction(this.powerSearchConfig));
          this.fuseSplashScreenService.hide();
        }
      }, err => {
        this.fuseSplashScreenService.hide();
        console.error(`Error in getDashboard Config ${err}`);
      });
    this.securityStore.pipe(select(getUserInfo), takeUntil(this.ngUnsubscribe)).subscribe((userInfo: UserInfo) => {
      if (userInfo) {
        this.userInfo = userInfo;
      }
    });
    this.setLawChangesFilterIdInSession();
    this.getExpertCornerArticle();

    // Inside a workspace, follow a Sync the way the workspace home page does (WS-E-25-03).
    this.workspaceSync.check();

    this.hasFeature$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(feature => {
      this.currentClientFeature = feature;
      if (feature('KPMG')) {
        this.hasKPMGFeature = true;
      }
    });



  }

  /** The Sync banner's button finished: follow the Sync it started, unless the user cancelled the confirm. */
  onWorkspaceSyncCommandFinished(response: PlatformCommandResponse): void {
    this.workspaceSync.onSyncCommandFinished(response);
  }

  private showWorkspaceSync(response: any): void {
    if (response?.fieldValues) {
      this.requireWorkspaceSync = response.fieldValues['RequireWorkspaceSync'];
      this.workspaceSyncMessageBar = response.fieldValues['WorkspaceSyncMessageBar'];
    }
  }

  private setXatBotHomePageModel() {
    this.xatBotDataService.getXatBotHomePageModel().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this.xatBotHomePageModel = res.fieldValues['XatBotHomePageModel'];
      this.setXatBotHomePageModelText(this.xatBotHomePageModel);
    });
  }

  private setXatBotHomePageModelText(data: XatBotHomePageModel) {
    if (data?.isShowTryXatBotButton) {
      this.xatBotHomePageModelText = {
        title: 'Meet XatBot',
        description: 'Introducing Orbitax XatBot, the conversational AI powered tax assistant for everyone with international tax questions.',
        buttonText: 'Try free for 7 days',
        state: 'try'
      }
    }
    else if (data?.isTrialOngoing || data?.isXatBotLicenseOngoing) {
      this.xatBotHomePageModelText = {
        title: 'Orbitax XatBot',
        description: 'XatBot delivers trusted, generative answers grounded in all tax content from the Orbitax International Tax Platform.',
        buttonText: 'Talk to XatBot',
        state: 'open'
      }
    }
    else if (!data?.isShowTryXatBotButton &&
      !data?.isTrialOngoing &&
      !data?.isXatBotLicenseOngoing) {
      this.xatBotHomePageModelText = {
        title: 'Orbitax XatBot',
        description: 'Thanks for checking out Orbitax XatBot, the conversational AI powered tax assistant for everyone with international tax questions.',
        buttonText: 'Get XatBot',
        state: 'upgrade'
      }
    }
  }

  private setXatBotSuggestedQuestions() {
    const statusQuery = new PlatformQuery();
    statusQuery.api = Api.XatBotApi;
    statusQuery.name = 'XatBotSuggestedQuestionsQuery';
    this.platformQueryService.executeQuery(statusQuery).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
      if (response && response.fieldValues['XatBotSuggestedQuestions']) {
        this.xatBotSuggestedQuestions = response.fieldValues['XatBotSuggestedQuestions'];
      }
    });
  }

  private setLawChangesFilterIdInSession() {
    let queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams['alertInfoId']) {
      let alertInfoId = queryParams['alertInfoId'];
      window.sessionStorage.setItem('alertInfoId', alertInfoId);
    }
  }

  tryXatBot() {
    this.openXatBot();
  }

  openXatBot(relativeUrl = 'xatbot') {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([relativeUrl])
    );
    window.open(url, '_blank');
  }

  xatBotFindOutMore() {
    const xatBotFindOutMoreUrl = 'https://orbitax.com/solutions/ai-tax-assistant';
    window.open(xatBotFindOutMoreUrl, '_blank');
  }

  upgradeNow() {
    if (!this.isLicensedUser) {
      this.xatBotDataService.upgradeNow();
    }
    else {
      this.xatBotDataService.contactSales();
    }
  }

  onXatBotQuestionClicked(question: string) {
    this.fuseSplashScreenService.show();
    const message = { question: question } as XatBotQuestionModel;
    this.xatBotDataService.postSendMessageCommand('', '', message, (payload) => {
      this.fuseSplashScreenService.hide();
      console.log('onXatBotQuestionClicked:::', payload);
      const url = `xatbot/chat/${payload.fieldValues['ThreadId']}`;
      this.openXatBot(url);
    }, '', false, { isMagicBarItem: true }, '', 'xatbot-research');
  }


  getExpertCornerArticle() {
    this.dashboardService.getExpertCornerArticle().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res) {
          this.expertCornerArticle = res;
          this.isExpertCornerArticleAvailable = true;
        }
      }, err => {
        console.error('Unable to fetch expert corner article in home page');
      });
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onMenuItemChanged(index: number) {
    this.currentMenuIndex = index;
    this.selectedGroupReports = this.updateDisplayText(this.powerSearchConfig.powerQueries[index].reports);
    this.selectedGroup = this.powerSearchConfig.powerQueries[index].groupHeader;
  }

  onClickedQueryText(reportId: string) {
   const command = new PlatformCommand('AccessToLegacyReportCommand', Api.FileStoreApi);
    command.fieldValues['ReportId'] = reportId;
    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        this.fuseSplashScreenService.hide();
        console.log('Command Response', commandResponse);
        if (commandResponse.fieldValues['RedirectToExternalUrl']) {
          console.log(`RedirectToExternalUrl : ${commandResponse.fieldValues['RedirectToExternalUrl']}`);
          window.open(commandResponse.fieldValues['RedirectToExternalUrl']);
          return;
        }
        switch (reportId) {
          case 'due-dates':
            if (this.currentClientFeature('DDT')) {
              this.getAnalyticReportToolLinkCommand();
            } else {
              this.router.navigateByUrl(`/promotion/ddt`);
            }
            break;
          case 'entities':
          case 'transactions':
            this.getEntitiesAndTransactionsAnalyticReportToolLinkCommand(reportId);
            break;
          case 'tax-news':
          case 'law-changes':
          case 'tax-treaties':
          case  'tax-topics':
            if (commandResponse.fieldValues['HasFeature']==false){
              this.router.navigateByUrl(`/promotion/itrce`);
            }else{
              this.getITRCEAnalyticReportToolLinkCommand(reportId);
            }
            break;
          case  'tax-forms':
            this.router.navigateByUrl(`/itrce-planner/forms`);
            break;
          default:
            this.router.navigateByUrl(`/home/${reportId}/rates`);
            break;
        }
      },
      error => {
        console.error('Failed To Execute command', error);
        this.fuseSplashScreenService.hide();
      });

  }

  private updateDisplayText(selectedGroupReports: any) {
    selectedGroupReports.forEach(report => {
      const lastIndex = report.displayQuery.lastIndexOf(report.reportHeader);

      report.displayQuery = report.displayQuery.slice(0, lastIndex);
    });
    return selectedGroupReports;
  }

  navigateToExpertCorner() {
    this.router.navigateByUrl('/taxnews/expertcorner/' + this.expertCornerArticle.id);
  }
  messageClickEvent(event) {
    if (event.id === 'close') {
      window.localStorage.setItem('NewsSubMsgClosed', 'true');
    }
    if (event.id === 'subscribe') {
      this.subscribeToNews(this.userInfo.email);
    }
  }
  private subscribeToNews(email: string) {
    const command = new PlatformCommand('UpdateNewsletterSubscriptionCommand', Api.Alert);
    this.commandService.executePlatformCommand(command).subscribe(response => {
      this.snackBarService.showInformation('Your subscription was successful!');
    });
  }
  toggleDAC6MdrResource() {
    this.isDAC6MdrResourceVisible = !this.isDAC6MdrResourceVisible;
  }
  toggleDAC6MdrResource1() {
    this.isDAC6MdrResourceVisible1 = !this.isDAC6MdrResourceVisible1;
  }
  toggleDAC6MdrResource2() {
    this.isDAC6MdrResourceVisible2 = !this.isDAC6MdrResourceVisible2;
  }

  private getCountryList() {
    this.projectStore.select(getCurrentProject).pipe(takeUntil(this.ngUnsubscribe)).subscribe(project => {
      const query = new PlatformQuery();
      query.api = 'EntityChartApi';
      query.name = 'DistinctCountryNameQuery';
      query.projectId = project.ProjectId;
      this.platformQueryService.executeQuery(query).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
        this.countryCount = res.fieldValues['Count'];
        this.currentProjectCountries = res.fieldValues['Countries'];
      });
    });

  }

  onClickCountries() {
    const dialogModel = DialogModel.create('Countries',
      'HomePageCountryDialogComponent',
      { countries: this.currentProjectCountries, },
      '600px', '700px',
      false);
    dialogModel.okCaption = 'Done';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
    });
  }

  getEntitiesAndTransactionsAnalyticReportToolLinkCommand(pageName: string) {
    const platformCommand = new PlatformCommand("OpenEntitiesAndTransactionAnalyticReportCommand", Api.FileStoreApi);
    platformCommand.fieldValues['DefaultGraphId'] = 'default-entity-transaction-graph';
    platformCommand.fieldValues['PageName'] = 'EntityTransactions';
    platformCommand.projectId = '[PROJECT_ID]';
    platformCommand.fieldValues['PageName'] = this.pageDictionary[pageName];
    this.executeCommand(platformCommand);
  }

  getITRCEAnalyticReportToolLinkCommand(pageName: string) {
    const platformCommand = new PlatformCommand('PowerBiGlobalReportViewLinkCommand', Api.VisualizerApi);
    platformCommand.projectId = '[PROJECT_ID]';
    platformCommand.fieldValues['ReportType'] = 'Analytic';
    platformCommand.fieldValues['Id'] = 'itrce-default-report';
    platformCommand.fieldValues['ReportType'] = 'Custom';
    platformCommand.fieldValues['Tag'] = 'itrce-analytics';
    platformCommand.fieldValues['SelectedPage'] = this.pageDictionary[pageName];
    platformCommand.fieldValues['RedirectUrlPrefix'] = `${this.redirectUrlDict[pageName]}`;
    this.executeCommand(platformCommand);
  }
  getAnalyticReportToolLinkCommand() {
    const platformCommand = new PlatformCommand("OpenDDTAnalyticReportCommand", Api.FileStoreApi);
    platformCommand.fieldValues['DefaultGraphId'] = 'default-due-date-graph';
    this.executeCommand(platformCommand);
  }

  executeCommand(command: PlatformCommand) {
    this.executeCommandToApi(command);
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        this.fuseSplashScreenService.hide();
        console.log('Command Response', commandResponse);
        this.commandService.handleResponse(commandResponse);
        if (commandResponse.fieldValues['RedirectCommand']) {
          this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
          return;
        }
        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          return;
        }
          if (commandResponse.fieldValues['RedirectToExternalUrl']) {
            console.log(`RedirectToExternalUrl : ${commandResponse.fieldValues['RedirectToExternalUrl']}`);
            window.open(commandResponse.fieldValues['RedirectToExternalUrl']);
            return;
          }
      },
        error => {
          console.error('Failed To Execute command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  protected readonly XatBotLicenseTypes = XatBotLicenseTypes;
}
